import { GtmPageView } from "@/app/gtm-page-view";
import { useSystemView } from "@/app/hook/use-system-view";
import {
  Content,
  Layout,
  Footer as ThemeFooter,
  Header as ThemeHeader,
} from "@/base/index";
import { MessageBoundary } from "@/components/message-boundary/index";
import { ModalLicenseAgreement } from "@/module/modal-license-agreement/index";
import { Outlet } from "react-router-dom";
import {
  FooterContacts,
  FooterNavigate,
  HeaderNavigate,
  HeaderSystemView,
  ModalHeaderMenu,
} from "../components/index";
import { ContextPageRootProvider } from "../context/root-provider";
import { useLayoutPageRootStyles } from "./index.style";

const LayoutPageRoot = () => {
  const { styles } = useLayoutPageRootStyles();
  const { status } = useSystemView();

  return (
    <ContextPageRootProvider>
      <Layout>
        <ThemeHeader className={styles.header}>
          <ModalHeaderMenu />
          {status === "enabled" && <HeaderSystemView />}
          <HeaderNavigate />
          <MessageBoundary />
        </ThemeHeader>
        <Content className={styles.content}>
          <GtmPageView />
          <ModalLicenseAgreement />
          <Outlet />
        </Content>
        <ThemeFooter className={styles.footer}>
          <FooterContacts />
          <FooterNavigate />
        </ThemeFooter>
      </Layout>
    </ContextPageRootProvider>
  );
};

export default LayoutPageRoot;
